import React, { Component } from 'react';
import { BasicSetup } from '../../components/basicsetup/BasicSetup';

/*
TODO: Security
has cookie expired?
*/

class SiteGroup extends Component {
  render() {
    return (
      <BasicSetup
        resourcename="sitegroup"
        humanname="Site Group"
        blockEditFromId={99999}
        blockEditToId={99999}
        {...this.props}
      />
    );
  }
}

export { SiteGroup };



// WEBPACK FOOTER //
// ./src/pages/sitegroup/SiteGroup.js